import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";

// import { Accordions } from "./Accordions";
// import { StudentLineGraphs } from "./StudentLineGraphs";
import { PupilReport, SavedReports } from "../ProgressReports/"
import MainTargets from "./MainTargets";
import { Common } from "../../../helper";

import "bootstrap/dist/css/bootstrap.min.css";
import "../../../assets/stlyes/SchoolAdminTabs.scss";

const GraphTabs = () => {
  const [ind, setInd] = useState(0);
  const [eventKey, setEventKey] = useState();
  let isNavCollapsed = useSelector((state) => state.styleData.isNavCollapsed)


  useEffect(() => {
    setInd(ind);
  }, [ind]);

  const changeTab = (newTabIndex) => {
    setInd(newTabIndex);
  };

  return (
    <div>
      <Tabs style={{ marginTop: "-38px" }}>
        <TabList className="schoolAdminTab-marking-tablist" style={{ marginLeft: "84px" }} >
          <Tab className={ind === 0 ? "react-tabs__tab--selected" : "progressTabs"} onClick={() => changeTab(0)}>
            {Common.ProgressThisYear}
          </Tab>
          <Tab
            className={ind !== 1 ? "progressTabs" : "react-tabs__tab--selected"} onClick={() => changeTab(1)} >
            {Common.Targets}
          </Tab>
          <Tab
            className={ind !== 2 ? "progressTabs" : "react-tabs__tab--selected"} onClick={() => changeTab(2)} >
            {Common.SavedReports}
          </Tab>
        </TabList>

        <TabPanel style={{ marginRight: !isNavCollapsed ? "170px" : "10px" }} itemID={ind}>
          {ind === 0 ? <PupilReport setInd={setInd} eventKey={eventKey} setEventKey={setEventKey} /> : ind === 1 ? <MainTargets eventKey={eventKey} /> : <SavedReports setInd={setInd} eventKey={eventKey} setEventKey={setEventKey} />}
          {/* {ind === 0 &&
            <div style={{ marginTop: "45px", marginLeft: "57px" }}>
              <Accordions setInd={setInd} setEventKey={setEventKey} />
            </div>
          } */}
        </TabPanel>
        <TabPanel itemID={ind} className="mainTargetTabPanel" style={{ marginRight: !isNavCollapsed ? "170px" : "10px" }}>
          {ind === 0 ? <PupilReport setInd={setInd} eventKey={eventKey} setEventKey={setEventKey} /> : ind === 1 ? <MainTargets eventKey={eventKey} /> : <SavedReports setInd={setInd} eventKey={eventKey} setEventKey={setEventKey}/>}
        </TabPanel>
        <TabPanel itemID={ind} className="mainTargetTabPanel" style={{ marginRight: !isNavCollapsed ? "170px" : "10px" }}>
          {ind === 0 ? <PupilReport setInd={setInd} eventKey={eventKey} setEventKey={setEventKey} /> : ind === 1 ? <MainTargets eventKey={eventKey} /> : <SavedReports setInd={setInd} eventKey={eventKey} setEventKey={setEventKey}/>}
        </TabPanel>
      </Tabs>
    </div>
  );
};

export { GraphTabs };
